const firebaseConfig = {
    apiKey: "AIzaSyC8BLwmAF0VMMMmKXVLrGIJkPYhDpq7MFQ",
    authDomain: "carbon-hood.firebaseapp.com",
    projectId: "carbon-hood",
    storageBucket: "carbon-hood.appspot.com",
    messagingSenderId: "173395605520",
    appId: "1:173395605520:web:07191b20ade6891329f295"
  };

export default firebaseConfig;